<template>
    <div class="margin-10-10-0">
        <!--搜索表单-->
        <div class="search-box">
            <!--搜索表单-->
            <el-form ref="searchForm" style="margin-left: 20px;" :inline="true" :model="searchForm">
                <el-form-item label="关键词:" prop="keyWord">
                    <el-input size="mini" v-model="searchForm.keyWord" placeholder="请输入关键词"></el-input>
                </el-form-item>
                <el-form-item label="登录账号:" prop="username">
                    <el-input size="mini" maxlength="30" show-word-limit v-model="searchForm.username" placeholder="登录账号"></el-input>
                </el-form-item>
                <el-form-item label="真实姓名:" prop="realName">
                    <el-input size="mini" maxlength="10" show-word-limit v-model="searchForm.realName" placeholder="真实姓名"></el-input>
                </el-form-item>
                <el-form-item label="公司名称:" prop="unitName">
                    <el-input size="mini" maxlength="32" show-word-limit v-model="searchForm.unitName" placeholder="单位名称"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button size="mini" icon="el-icon-search" type="primary" plain v-display:admin-find @click="()=>{this.searchForm.pager.page=1;this.submit();}">查询</el-button>
                    <el-button size="mini" icon="el-icon-refresh" type="warning" plain @click="clear">清空</el-button>
                    <el-button size="mini" plain type="success" icon="el-icon-refresh-left" @click="()=>{this.searchForm.pager.page=1;this.submit();}">刷新</el-button>
                    <el-button size="mini" plain type="primary" v-display:admin-save icon="el-icon-plus" @click="showAddDialog">新增</el-button>
                    <el-dropdown>
                        <el-button type="primary" size="mini" plain style="margin: 0px 10px 0px 10px">
                            批量操作<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item v-display:admin-batchDelete icon="el-icon-delete" @click.native="batchDelete">批量删除</el-dropdown-item>
                            <el-dropdown-item v-display:admin-batchDelete icon="el-icon-refresh" @click.native="batchResetPwd">批量重置密码</el-dropdown-item>
                            <el-dropdown-item v-display:admin-batchUpdate icon="el-icon-delete" @click.native="showBatchUpdateDialog">批量修改</el-dropdown-item>
                            <el-dropdown-item v-display:admin-leadingIn icon="el-icon-upload" @click.native="leadingInAdmin">导入</el-dropdown-item>
                            <el-dropdown-item v-display:admin-export icon="el-icon-download" @click.native="exportAdmin">导出</el-dropdown-item>
                            <el-dropdown-item v-display:admin-exportField icon="el-icon-download" @click.native="exportAdminDialog">导出选择字段</el-dropdown-item>
                            <el-dropdown-item v-display:admin-exportModule icon="el-icon-download" @click.native="exportAdminModule('upsertForm')">下载模板</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </el-form-item>
            </el-form>
        </div>
        <!--表格-->
        <el-table border size="mini" class="table-ui" :stripe="true" @selection-change="changeFun" :data="tableData" style="width: 100%" @sort-change="sortChange">
            <el-table-column type="selection" width="40px" align="center"></el-table-column>
            <el-table-column prop="portrait" label="头像" align="center">
                <template slot-scope="scope">
                    <el-image class="avatar" v-if="scope.row.portrait" :style="{'width':'70px','height':'70px','border-radius':'100%'}" :src="config.resPre+scope.row.portrait" :preview-src-list="[config.resPre+scope.row.portrait]" alt=""/>
                    <el-image class="avatar" v-else :style="{'width':'70px','height':'70px','border-radius':'100%'}" src="@/assets/frame/images/blacksan.jpg" alt=""/>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" prop="username" label="登录账号"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" prop="realName" label="真实姓名"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" prop="roleNames" label="所属角色"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" prop="phone" label="电话号码"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" prop="unitName" label="公司名称"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" prop="hotelNames" label="所属酒店"></el-table-column>
            <el-table-column show-overflow-tooltip prop="createTime" label="创建时间"></el-table-column>
            <el-table-column fixed="right" label="操作" width="350">
                <template slot-scope="scope">
                    <el-button type="primary" v-display:admin-update plain @click="showUpdateDialog(scope.row.id)" size="mini">修改</el-button>
                    <el-button type="success" v-display:admin-openSysRole plain @click="showSetRoleDialog(scope.row.id)" size="mini">配置角色</el-button>
                    <el-button type="warning" v-display:admin-delete plain @click="deleteData(scope.row.id)" size="mini">删除</el-button>
                    <el-button type="danger" v-display:admin-resetPwd plain @click="resetPwd(scope.row.id)" size="mini">重置密码</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                style="margin-top: 10px; text-align: center;"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[10, 20, 30, 40, 50, 100]"
                :total="searchForm.pager.totalCount"
                :page-size="searchForm.pager.pageSize"
                :current-page.sync="searchForm.pager.page"
                @size-change="sizeChange"
                @current-change="currentChange"
                @prev-click="currentChange"
                @next-click="currentChange">
        </el-pagination>
        <!--添加或者修改表单-->
        <el-dialog :close-on-click-modal="false"  :title="dialog.title" width="750px" :visible.sync="dialog.dialogFormVisible">
            <el-form :model="upsertForm" :rules="rules" class="upsertForm" ref="upsertForm" label-width="120px" :inline="true">
                <input type="hidden" :value="upsertForm.id">
                <el-form-item label="登录账号" prop="username">
                    <el-input size="mini" maxlength="30" show-word-limit v-model="upsertForm.username" placeholder="请输入登录账号" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="真实姓名" prop="realName">
                    <el-input size="mini" maxlength="10" show-word-limit v-model="upsertForm.realName" placeholder="请输入真实姓名" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="电话号码" prop="phone">
                    <el-input size="mini" maxlength="16" show-word-limit v-model="upsertForm.phone" placeholder="请输入电话号码" auto-complete="off"></el-input>
                </el-form-item>
               <el-form-item label="公司名称" prop="unitName">
                    <el-input size="mini" maxlength="255" show-word-limit v-model="upsertForm.unitName" placeholder="请输入公司名称" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="分管酒店" prop="hotelIds">
                    <el-select size="mini" filterable multiple collapse-tags v-model="upsertForm.hotelIds" placeholder="请选择酒店">
                        <el-option v-for="item in hotelList" :key="item.id" :label="item.title" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="mini" @click="dialog.dialogFormVisible = false">取 消</el-button>
                <el-button size="mini" type="primary" v-display:admin-save v-if="dialog.title=='增加'" @click="saveOrUpdate('upsertForm')">确 定</el-button>
                <el-button size="mini" type="primary" v-display:admin-update v-else @click="saveOrUpdate('upsertForm')">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" @open="openRoleDialog" :title="sysRoleDialog.title" width="700px" :visible.sync="sysRoleDialog.dialogFormVisible">
            <div style="margin-left: 30px">
                <el-transfer
                        filterable
                        v-model="roles"
                        :data="sysRoles.data"
                        :titles="titles"
                        :props="defaultProps">
                </el-transfer>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button size="mini" @click="sysRoleDialog.dialogFormVisible = false">取 消</el-button>
                <el-button size="mini" type="primary" v-display:admin-setSysRole @click="setSysRoles()">确 定</el-button>
            </div>
        </el-dialog>
        <!--批量修改-->
        <el-dialog :close-on-click-modal="false" :title="batchDialog.title"  width="750px" :visible.sync="batchDialog.dialogFormVisible">
            <el-form class="upsertForm"  :model="upsertForm" ref="upsertForm" label-width="80px" :inline="true">
                <el-form-item label="所属酒店" prop="jobId">
                    <el-select size="mini" filterable v-model="upsertForm.hotelIds" placeholder="请选择职务">
                        <el-option v-for="item in hotelList" :key="item.id" :label="item.title" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="公司名称" prop="unitName">
                    <el-input size="mini" maxlength="255" show-word-limit v-model="upsertForm.unitName" placeholder="请输入公司名称" auto-complete="off"></el-input>
                </el-form-item>
                <!--<el-form-item label="所属部门" prop="departmentId">
                    <el-select size="mini" filterable v-model="upsertForm.departmentId" placeholder="请选择部门">
                        <el-option v-for="item in departmentList" :key="item.id" :label="item.name" :value="item.id" @click.native="setDepartmentName"></el-option>
                    </el-select>
                </el-form-item>-->
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="mini" @click="batchDialog.dialogFormVisible = false">取 消</el-button>
                <el-button size="mini" type="primary" @click="batchUpdate('upsertForm')">确 定</el-button>
            </div>
        </el-dialog>
        <!--选择字段导出-->
        <el-dialog :close-on-click-modal="false"  :title="exportDialogExcel.title"  width="650px" :visible.sync="exportDialogExcel.dialogFormVisible">
            <div style="height: 400px;overflow-y: auto;width: 100%" >
                <!--表格-->
                <el-table border size="mini"  :stripe="true" :data="tableFieldData" style="margin-top: 20px" @selection-change="changeTableFieldFun"  >
                    <el-table-column type="selection" fixed="left" width="40"></el-table-column>
                    <el-table-column prop="key" label="英文字段名" ></el-table-column>
                    <el-table-column prop="name" label="中文字段名" ></el-table-column>
                    <el-table-column prop="newName" label="重命名字段" >
                        <template slot-scope="scope">
                            <el-input  placeholder="重命名字段" maxlength="20" size="mini" v-model="tableFieldData[scope.$index].newName"></el-input>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button plain size="mini" @click="exportDialogExcel.dialogFormVisible = false">取 消</el-button>
                <el-button plain size="mini" icon="el-icon-download"  type="success" @click="exportAdminByField">确认导出</el-button>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :title="dialogExcel.title"   width="650px" :visible.sync="dialogExcel.dialogFormVisible">
            <div v-if="dialogExcel.title=='导入结果'">
                <el-badge :value="cnt" class="item" style="margin: 10px 20px 10px 0px">
                    <el-button size="mini">导入总数</el-button>
                </el-badge>
                <el-badge :value="successCnt" class="item" type="primary" style="margin: 10px 20px 10px 10px">
                    <el-button size="mini">导入成功</el-button>
                </el-badge>
                <el-badge :value="errorNumber" class="item" type="warning" style="margin: 10px 20px 10px 10px">
                    <el-button size="mini">导入失败</el-button>
                </el-badge>
                <!--表格-->
                <el-table border size="mini" v-show="errorNumber>0" :stripe="true" :data="uploadData" style="margin-top: 10px">
                    <el-table-column show-overflow-tooltip prop="username" label="用户名"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="password" label="密码"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="realName" label="真实姓名"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="phone" label="电话号码"></el-table-column>
                    <!--<el-table-column show-overflow-tooltip prop="email" label="电子邮件"></el-table-column>-->
                    <el-table-column show-overflow-tooltip prop="portrait" label="头像"></el-table-column>
                    <!--<el-table-column show-overflow-tooltip prop="departmentId" label="部门编号"></el-table-column>-->
                    <!--<el-table-column show-overflow-tooltip prop="departmentName" label="部门名称"></el-table-column>-->
                    <el-table-column show-overflow-tooltip prop="createTime" label="创建时间" sortable="custom"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="updateTime" label="修改时间" sortable="custom"></el-table-column>
                </el-table>
            </div>
            <div v-if="dialogExcel.title=='导入'">
                <el-upload class="lead-in-th"
                           style="border:1px #4dbd73 solid;text-align: center;line-height: 50px;border-radius: 5px;margin-top:30px;color: #4dbd73 ;"
                           :action="uploadUrl"
                           :headers="headers"
                           multiple
                           :show-file-list="false"
                           :on-success="handleAdminSuccess"
                           :before-upload="beforeAdminUpload">
                    <div class="" style="width: 440px;height: 50px;">导入</div>
                </el-upload>
                <div class="lead-in-th" @click="exportAdminModule('upsertForm')" style="border:1px #4dbd73 solid;text-align: center;line-height: 50px;border-radius: 5px;margin-top:30px;color: #fff ;background-color: #51c993">下载模板</div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import axios from 'axios';
    import fileDownload from "js-file-download";
    import md5 from 'md5';
    let roleChecked = [];
    export default {
        name: "admin",
        data() {
            return {
                config: config,
                props: {
                    label: 'title',
                    children: 'zones'
                },
                sysRoles: {
                    data: []
                },
                searchForm:{
                    username: '',
                    password: '',
                    realName: '',
                    phone: '',
                    unitName: '',
                    portrait: '',
                    hotelIds: '',
                    hotelNames: '',
                    type:'0',
                    updateTime: '',
                    createTime: '',
                    keyWord:'',
                    pager:{
                        sortField:'create_time',
                        sortOrder:'desc',
                        page:1,
                        pageSize:10,
                        totalCount:0,
                        like:'username,realName,phone,unitName,hotelNames',
                        keyWordField:'username,realName,phone,unitName,hotelNames',
                    }
                },
                tableData: [],
                upsertForm:{
                    id:'',
                    username:'',
                    password:'',
                    realName:'',
                    phone:'',
                    unitName:'',
                    portrait:'',
                    hotelIds:'',
                    hotelNames:'',
                    updateTime:'',
                    createTime:''
                },
                rules: {
                    username: [
                        {required: true, message: '请输入登录账号', trigger: 'blur'},
                        {max: 30, message: '长度必须少于30个字符', trigger: 'blur'}
                    ],
                    realName: [
                        {required: true, message: '请输入真实姓名', trigger: 'blur'},
                        {max: 10, message: '长度必须少于10个字符', trigger: 'blur'}
                    ],
                    unitName: [
                        {required: true, message: '请输入公司名称', trigger: 'blur'},
                        {max: 255, message: '长度必须少于255个字符', trigger: 'blur'}
                    ],
                    phone: [
                        {required: true, message: '请输入电话号码', trigger: 'blur'},
                        {max: 16, message: '长度必须少于16个字符', trigger: 'blur'}
                    ],
                    hotelIds: [
                        { required: true, message: '请输入管辖酒店', trigger: 'blur' },
                    ],
                    hotelNames: [
                        { required: true, message: '请输入管辖酒店', trigger: 'blur' },
                    ],
                },
                dialog: {
                    dialogFormVisible: false,
                    title: '增加'
                },
                sysRoleDialog: {
                    dialogFormVisible: false,
                    title: '配置角色',
                    adminId: ''
                },
                unitList:[],
                roles:[],
                titles:["所有角色","已选角色"],
                defaultProps: {
                    key: 'id',
                    label: 'title'
                },
                hotelList:[],
                // departmentList:[],
                batchDialog:{
                    dialogFormVisible:false,
                    title:'批量修改'
                },
                exportDialogExcel:{
                    dialogFormVisible:false,
                    title:'导出选择字段',
                    id:'',
                },
                tableFieldData:[],
                fieldData:[],
                excelParam:{
                    data:'',
                    excelExportList:''
                },
                cnt: '',
                successCnt: '',
                errorNumber: '',
                uploadData: [],
                uploadUrl: `${home}/admin/importByExcel`,
                dialogExcel:{
                    dialogFormVisible:false,
                    title:'导入'
                },
                headers: {
                    token: this.$store.getters.getToken
                },
            }
        },
        created() {
            // this.findDepartmentList();
            this.findHotelList();
            this.submit();
        },
        methods: {
            changeTableFieldFun(row) {
                this.fieldData = [];
                for (var i = 0; i < row.length; i++) {
                    this.fieldData.push(row[i]);
                }
            },
            changeFun(row) {
                this.rowData = [];
                for (var i = 0; i < row.length; i++) {
                    this.rowData.push(row[i].id);
                }
            },
            showSetRoleDialog(id) {
                this.sysRoleDialog.dialogFormVisible = true;
                this.sysRoleDialog.adminId = id;
            },
            selectionChange(checked) {
                roleChecked = checked.map(obj => obj.id);
            },
            setSysRoles() {
                axios({
                    url: `${home}/admin/delsertAdminSysRoles`,
                    method: 'POST',
                    data: {adminId: this.sysRoleDialog.adminId, roleIds: this.roles.join(",")}
                }).then(res => {
                    this.$message({
                        type: 'success',
                        message: '配置成功!'
                    });
                    this.sysRoleDialog.dialogFormVisible = false;
                    this.submit();
                })
            },
            openRoleDialog() {
                this.sysRoles.data = [];
                axios({
                    url: `${home}/admin/findSysRolesByAdminId/${this.sysRoleDialog.adminId}`,
                    method: 'GET'
                }).then(res => {
                    this.roles = res.data2;
                    this.sysRoles.data = res.data;
                }).catch(error => {

                })
            },
            sortChange({column, prop, order}) {
                this.searchForm.pager.sortField = prop;
                this.searchForm.pager.sortOrder = order ? order.replace(/ending$/, '') : '';
                this.submit();
            },
            sizeChange(pageSize) {
                this.searchForm.pager.pageSize = pageSize;
                this.submit();
            },
            currentChange(page) {
                this.searchForm.pager.page = page;
                this.submit();
            },
            showAddDialog() {
                this.dialog.dialogFormVisible = true;
                this.dialog.title = '增加';
                objUtil.setToDefault(this.upsertForm);
                this.$nextTick(() => {
                    this.$refs.upsertForm.clearValidate();
                });

            },
            showUpdateDialog(id) {
                axios({
                    url: `${home}/admin/findAdminById/${id}`,
                    method: 'GET'
                }).then(res => {
                    this.upsertForm = res.data;
                    this.dialog.dialogFormVisible = true;
                    this.dialog.title = '修改';
                    if(this.upsertForm.hotelIds){
                        this.upsertForm.hotelIds = this.upsertForm.hotelIds.split(',');
                    }
                    this.$nextTick(() => {
                        this.$refs.upsertForm.clearValidate();
                    });
                }).catch(error => {

                })

            },
            saveOrUpdate(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        if(this.upsertForm.hotelIds){
                            this.upsertForm.hotelIds = this.upsertForm.hotelIds.join(",");
                        }
                        this.upsertForm.type='0';
                        axios({
                            url: `${home}/admin/${this.dialog.title === '增加' ? 'saveAdmin' : 'updateAdmin'}`,
                            method: 'POST',
                            data: this.upsertForm
                        }).then(res => {
                            this.$message({
                                message: this.dialog.title + '成功',
                                type: 'success'
                            });
                            this.dialog.dialogFormVisible = false;
                            this.submit();
                        }).catch(error => {
                            //do something
                        })
                    }
                })
            },
            deleteData(id) {
                this.$confirm('删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios({
                        url: `${home}/admin/deleteAdmin/${id}`,
                        method: 'GET'
                    }).then(res => {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.submit();
                    }).catch(error => {

                    })
                });
            },
            submit(){
                axios({
                    url:`${home}/admin/findAdminsByCondition`,
                    method:'POST',
                    data:this.searchForm
                }).then(res=>{
                    if(res.data.length===0&&this.searchForm.pager.page>1&&res.totalCount>0){
                        this.searchForm.pager.page--;
                        this.submit();
                    }else{
                        this.tableData=res.data;
                        this.searchForm.pager.totalCount=res.totalCount;
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            clear() {
                this.$refs['searchForm'].resetFields();
            },
            resetPwd(id) {
                this.$prompt('请输入重置新密码', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern: /([a-zA-Z0-9]).{6,16}/,
                    inputErrorMessage: '密码必须由数字、字母组合,请输入6-16位'
                }).then(({value}) => {
                    this.upsertForm.password = md5(value);
                    this.upsertForm.id = id;
                    axios({
                        url: `${home}/admin/resetPwd`,
                        method: 'POST',
                        data: this.upsertForm
                    }).then(res => {
                        this.$message({
                            type: 'success',
                            message: '重置成功!'
                        });
                    }).catch(function (error) {
                        console.log(error);
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消重置'
                    });
                });
            },
            batchResetPwd() {
                if (this.rowData.length <= 0) {
                    this.$message({
                        type: "error",
                        message: "请勾选数据!"
                    });
                    return;
                }
                this.$prompt('请输入重置新密码', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern: /(?=.*\d)(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{6,20}/,
                    inputErrorMessage: '只能输入6-20个字符'
                }).then(({value}) => {
                    this.upsertForm.password = md5(value);
                    this.upsertForm.rowData = this.rowData;
                    axios({
                        url: `${home}/admin/batchResetPwd`,
                        method: 'POST',
                        data: this.upsertForm
                    }).then(res => {
                        this.$message({
                            type: 'success',
                            message: '批量重置成功!'
                        });
                    }).catch(function (error) {
                        console.log(error);
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消重置'
                    });
                });
            },
            batchDelete() {
                if (this.rowData.length <= 0) {
                    this.$message({
                        type: "error",
                        message: "请勾选数据!"
                    });
                    return;
                }
                this.$confirm("确认批量删除吗?", "温馨提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    axios({
                        url: `${home}/admin/batchDeleteAdmin`,
                        method: "post",
                        data: {
                            rowData: this.rowData
                        }
                    }).then(res => {
                        this.$message({
                            type: "success",
                            message: "删除成功!"
                        });
                        this.submit();
                    }).catch(error => {
                    });
                }).catch(() => {
                    this.$message({
                        type: "error",
                        message: "删除失败!"
                    });
                });
            },
           /* findDepartmentList(){
                axios({
                    url: `${home}/sysDdList/findDepartMentsListByCondition`,
                    method: "GET",
                }).then(res => {
                    this.departmentList = res.data;
                }).catch(error => {
                });
            },*/
            findHotelList(){
                axios({
                    url: `${home}/sysDdList/findHotelListByCondition`,
                    method: "GET",
                }).then(res => {
                    this.hotelList = res.data;
                }).catch(error => {
                });
            },
         /*   setDepartmentName(e){
                this.upsertForm.departmentName = e.target.innerText;
            },*/
            showBatchUpdateDialog(){
                if(this.rowData.length>0){
                    this.batchDialog.dialogFormVisible=true;
                    this.batchDialog.title='批量修改';
                    objUtil.setToDefault(this.upsertForm);
                    this.$nextTick(()=>{
                        this.$refs.upsertForm.clearValidate();
                    });
                }else{
                    this.$message({
                        type: "error",
                        message: "请勾选数据!"
                    });
                }
            },
            batchUpdate(){
                if (this.rowData.length <= 0) {
                    this.$message({
                        type: "error",
                        message: "请勾选数据!"
                    });
                    return;
                }
                this.$confirm("确认批量修改吗?", "温馨提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    this.upsertForm.rowData = this.rowData;
                    axios({
                        url: `${home}/admin/batchUpdateAdmin`,
                        method: "post",
                        data: this.upsertForm
                    }).then(res => {
                        this.$message({
                            type: "success",
                            message: "修改成功!"
                        });
                        this.submit();
                        this.batchDialog.dialogFormVisible=false;
                    }).catch(error => {});
                }).catch(() => {
                    this.$message({
                        type: "error",
                        message: "修改失败!"
                    });
                });
            },
            leadingInAdmin() {
                this.dialogExcel.dialogFormVisible = true;
                this.dialogExcel.title = '导入';
            },
            exportAdmin() {
                axios({
                    url: `${home}/admin/exportAdmin`,
                    method: "POST",
                    data: this.searchForm,
                    responseType: "arraybuffer"
                }).then(res => {
                    fileDownload(res, "管理员列表.xls");
                });
            },
            exportAdminModule() {
                axios({
                    url: `${home}/admin/exportAdminModule`,
                    method: "GET",
                    responseType: "arraybuffer"
                }).then(res => {
                    fileDownload(res, "管理员列表模板.xls");
                });

            },
            handleAdminSuccess(res, file) {
                this.loading.close();
                this.dialogExcel.dialogUploadVisible = false;
                if (res.result.success== true) {
                    if(res.data.successCnt>0){
                        this.cnt = res.data.sumCnt;
                        this.successCnt = res.data.successCnt;
                        this.errorNumber = res.data.errorNumber;
                        this.uploadData = res.data.objectList;
                        this.$message({
                            message: "导入成功",
                            type: "success"
                        });
                        this.submit();
                        this.dialogExcel.dialogFormVisible = true;
                        this.dialogExcel.title = '导入结果';
                    }else{
                        this.cnt = res.data.sumCnt;
                        this.successCnt = res.data.successCnt;
                        this.errorNumber = res.data.errorNumber;
                        this.uploadData = res.data.objectList;
                        this.$message({
                            message: "导入失败",
                            type: "warning"
                        });
                        this.dialogExcel.dialogFormVisible = true;
                        this.dialogExcel.title = '导入结果';
                    }
                } else{
                    this.$message({
                        message: "模板有误或数据为空",
                        type: "error"
                    });
                    this.dialogExcel.dialogUploadErrorVisible = true;
                }
            },
            beforeAdminUpload(file) {
                this.loading = this.$loading({
                    lock: true,
                    text: "Loading",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)"
                });
                const extension = file.name.split(".")[1] === "xls";
                const extension2 = file.name.split(".")[1] === "xlsx";
                if (!extension && !extension2) {
                    this.loading.close();
                    this.$message.error("上传模板只能是 xls、xlsx 格式!");
                }
                return extension || extension2;
            },
            exportAdminDialog(){
                axios({
                    url: `${home}/admin/getAdminTableField`,
                    method: "GET",
                }).then(res => {
                    this.tableFieldData = res.data;
                    this.exportDialogExcel.dialogFormVisible = true;
                    this.exportDialogExcel.title = '导出选择字段';
                    this.exportDialogExcel.id = this.id;
                });

            },
            exportAdminByField() {
                if(this.fieldData.length<=0 ){
                    this.$message({
                        type: "error",
                        message: "请选择需要导出的字段!"
                    });
                }else{
                    this.excelParam.data = this.searchForm;
                    this.excelParam.excelExportList = this.fieldData;
                    axios({
                        url: `${home}/admin/exportAdminByField`,
                        method: "POST",
                        data: this.excelParam,
                        responseType: "arraybuffer"
                    }).then(res => {
                        fileDownload(res, "管理员列表.xls");
                    });
                }

            },

        }
    }
</script>

